module.exports = __webpack_public_path__ + "img/up-right-from-square.871c91ca.svg";